var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGantsElectricien(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "gants_\\xE9lectricien",
    "data-name": "gants \\xE9lectricien",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1047.11 881",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:url(#D\xE9grad\xE9_sans_nom_29);}.cls-4{fill:#c19a59;}.cls-5{fill:#e2d6b0;}.cls-6{clip-path:url(#clip-path-2);}.cls-7{fill:url(#D\xE9grad\xE9_sans_nom_29-2);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-594.89 -666.75)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1591,696s57,257-3,331c-97-15-307-47-392-46-55,18-50,31-140,57s-234,38-234,38c-41-4-49-55,5-71,0,0,76.33-16.53,115-23,97.71-16.34,17-28-21-20l-205,6c-50-5-58-48,0-69l70-15-111,5c-50-12-48-58,14-73s99-18,99-18l-91-9c-38-7-43-51,28-62,0,0,53-2,64-2-62-7-40-54,7-58,0,0,146-1,186,1s149,43,180,59c43,12,180-2,180-2Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_29",
    x1: 1127.63,
    y1: 666.75,
    x2: 1127.63,
    y2: 1076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cfc296"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#ccbd91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#c3af84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bda47a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(-594.89 -666.75)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1223,1187s-38,11-87-13-292.51-28.82-350-17c-82.37,16.94-37.19,61.26-9,58,0,0,111,3,123,7s-3,7-3,7-156.87-1.54-199,10c-72.18,19.78-27,56,10,59,0,0,166,1,185,10s-23,9-23,9-141.47,5.13-215,30c-60,28-6,70,22,59,0,0,190-11,204-7s-122.09,6.73-177,25c-59,23-26,60,10,59l109-4c-34,18-42,76,34,68,0,0,137-13,212-32s114.47-53.66,126-57c37.77-10.94,371,26,401,35,62-70,59-319,5-383C1601,1110,1264,1186,1223,1187Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_29-2",
    x1: 1134.91,
    y1: 1110,
    x2: 1134.91,
    y2: 1547.75,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_29"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "gans \xE9lectricien") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1591,696s57,257-3,331c-97-15-307-47-392-46-55,18-50,31-140,57s-234,38-234,38c-41-4-49-55,5-71,0,0,76.33-16.53,115-23,97.71-16.34,17-28-21-20l-205,6c-50-5-58-48,0-69l70-15-111,5c-50-12-48-58,14-73s99-18,99-18l-91-9c-38-7-43-51,28-62,0,0,53-2,64-2-62-7-40-54,7-58,0,0,146-1,186,1s149,43,180,59c43,12,180-2,180-2Z",
    transform: "translate(-594.89 -666.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M709,696l76-12,172,4s34,11,32,13-50,176-50,176L631,913,595,776Z",
    transform: "translate(-594.89 -666.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M683.49,955.34S683,930,724,914s201-24,227-30c33.71-10.3,38.57-36.55,49-71,6.17-20.37-1.37-44.49,0-68,1.26-21.64,12.23-42.62,0-63-109-15-233.89-5.06-233.89-5.06L741,688l6,8s173-9,192-4,20,7,20,7-26,10-29,25c-19,0-144.41.56-144.41.56L683,725s-30,44-27,46,16,10,16,10,2-16,31-19,216,4,216,4,20,1,23,4c-20,6-25,11-34,22-45,0-202.6,7.46-229,15-28,8-53,51-49,55s14.69,9.38,14.69,9.38S651,860,683,855s256-18,256-18,1,34-43,34L676,897l-12,73Z",
    transform: "translate(-594.89 -666.75)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1223,1187s-38,11-87-13-292.51-28.82-350-17c-82.37,16.94-37.19,61.26-9,58,0,0,111,3,123,7s-3,7-3,7-156.87-1.54-199,10c-72.18,19.78-27,56,10,59,0,0,166,1,185,10s-23,9-23,9-141.47,5.13-215,30c-60,28-6,70,22,59,0,0,190-11,204-7s-122.09,6.73-177,25c-59,23-26,60,10,59l109-4c-34,18-42,76,34,68,0,0,137-13,212-32s114.47-53.66,126-57c37.77-10.94,371,26,401,35,62-70,59-319,5-383C1601,1110,1264,1186,1223,1187Z",
    transform: "translate(-594.89 -666.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M676.85,1441.41S863,1426,884,1428s33.13-23.31-10.44-26.66S648,1421,648,1421Z",
    transform: "translate(-594.89 -666.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M676.85,1356.41C729,1342,863,1341,884,1343s33.13-23.31-10.44-26.66S648,1336,648,1336s28.65-2.52-30,22S624.7,1370.82,676.85,1356.41Z",
    transform: "translate(-594.89 -666.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M686.23,1252c52.94-11.17,186.75-3.93,207.58-.64s34.5-21.23-8.77-27.24-226.35,5.73-226.35,5.73,28.75-.74-31.3,20.12S633.29,1263.13,686.23,1252Z",
    transform: "translate(-594.89 -666.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M803.82,1533.67S801,1513,848,1496s153-7,210-55,65-130,45-125-112,40-112,105c-2,20-46,33-61,32s-95,13.77-117.53,26.39S775,1541,775,1541Z",
    transform: "translate(-594.89 -666.75)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGantsElectricien);
export default __webpack_public_path__ + "static/media/gants_electricien.0987c578c1b3911d3c38d6a4ca4fad3c.svg";
export { ForwardRef as ReactComponent };